import DepartmentItem from './DepartmentItem';

export default DepartmentItem;
